import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import getOpcoesConsulta from "../../service/getOpcoesConsulta";
import { Dropdown } from "primereact/dropdown";


export default function MotorCreditoFormulaCadastrar({motorCreditoFormula, onClose, onSave}:{motorCreditoFormula:any, onClose: () => void, onSave: (motorCreditoFormula:any) => void}) {
  const { t } = useTranslation();
  const [opcoes, setOpcoes] = useState<any>([]);
  const defaultValues = {
    descricao: '',
    localizacao: '',
    permissao: null
  };
  defaultValues.descricao = motorCreditoFormula.descricao ? motorCreditoFormula.descricao.toString() : ''
  defaultValues.localizacao = motorCreditoFormula.localizacao ? motorCreditoFormula.localizacao.toString() : ''
 
  
  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.descricao && save(data);
  };

 
  const save = (data:any) => {
    const formula = {
      id: motorCreditoFormula.id? motorCreditoFormula.id : undefined,
      descricao:data.descricao,
      localizacao:data.localizacao,
      idPermissao: data.permissao
    }
    window.scrollTo(0, 0);
    onSave(formula);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  useEffect(() => {
    getOpcoesConsulta().then( (data) => {
      setOpcoes(data);
      if(motorCreditoFormula.id){
        setValue('permissao', motorCreditoFormula.idPermissao);
      }
  })
  }, [])



  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="descricao"
                      control={control}
                      rules={{ required: 'Descrição é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="descricao" className="font-bold block mb-2 required">{t('descricao')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="localizacao"
                      control={control}
                      rules={{ required: 'Localização é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.localizacao })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="localizacao" className="font-bold block mb-2 required">{t('localizacao')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col">
                <Controller
                      name="permissao"
                      control={control}
                      rules={{ required: 'Documento é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.permissao })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="opcao" className="font-bold block mb-2 required">{t('opcao')} </label>
                                <Dropdown style={{width: '50%'}} value={field.value}  onChange={(e) => field.onChange(e.value)} options={opcoes} optionLabel="label" placeholder="Selecione Opção" 
                                  filter className="w-full md:w-14rem" />  
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          
       
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

